import ApplicationFallback from './ApplicationFallback';

export default ApplicationFallback;
